'use client';
import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../stitches.config.js';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDownIcon } from '@radix-ui/react-icons';

const StyledAccordion = styled(AccordionPrimitive.Root, {});
const Accordion = React.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(StyledAccordion, Object.assign({ ref: forwardedRef }, props, (props.type === 'single' ? { collapsible: true } : {})), children));
});
const StyledItem = styled(AccordionPrimitive.Item, {
    borderTop: '1px solid $colors$gray6',
    '&:last-of-type': {
        borderBottom: '1px solid $colors$gray6',
    },
});
const StyledHeader = styled(AccordionPrimitive.Header, {
    all: 'unset',
});
const StyledTrigger = styled(AccordionPrimitive.Trigger, {
    all: 'unset',
    boxSizing: 'border-box',
    userSelect: 'none',
    '&::before': {
        boxSizing: 'border-box',
    },
    '&::after': {
        boxSizing: 'border-box',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: '$2',
    color: '$hiContrast',
    width: '100%',
    '@hover': {
        '&:hover': {
            backgroundColor: '$gray2',
        },
    },
    '&:focus': {
        outline: 'none',
        boxShadow: 'inset 0 0 0 1px $colors$gray8, 0 0 0 1px $colors$gray8',
    },
    svg: {
        transition: 'transform 175ms cubic-bezier(0.65, 0, 0.35, 1)',
    },
    '&[data-state="open"]': {
        svg: {
            transform: 'rotate(180deg)',
        },
    },
});
const AccordionTrigger = React.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(StyledHeader, null,
        React.createElement(StyledTrigger, Object.assign({}, props, { ref: forwardedRef }),
            children,
            React.createElement(ChevronDownIcon, null))));
});
const StyledContent = styled(AccordionPrimitive.Content, {
    p: '$2',
});
const AccordionItem = StyledItem;
const AccordionContent = StyledContent;

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
